import { render, staticRenderFns } from "./DefaultAttention.vue?vue&type=template&id=66d7b41b&"
import script from "./DefaultAttention.vue?vue&type=script&lang=ts&"
export * from "./DefaultAttention.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports